import "../global.css"
import { FrontendTechList, BackendLLMTechList, DevOpsTechList } from "../assets/techstack/tech-list.tsx";

function Technologies() {
  return (
    <main className="max-width pt-10 pb-20">
      <h1 className="text-gradient text-2xl md:text-4xl xl:text-5xl font-bold mb-10">
        Tools &amp; Technologies
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        <section className="flex flex-col gap-4">
          <h2 className="text-xl text-dark-heading dark:text-light-heading md:text-2xl font-bold border-b border-slate-200 dark:border-slate-700 pb-3">
            Frontend
          </h2>
          <ul className="space-y-2">
            {FrontendTechList.map((tech, index) => (
              <li key={index} className="text-base font-medium text-content flex items-center gap-2">
                <span className="text-sky-500">—</span> {tech}
              </li>
            ))}
          </ul>
        </section>
        <section className="flex flex-col gap-4">
          <h2 className="text-xl text-dark-heading dark:text-light-heading md:text-2xl font-bold border-b border-slate-200 dark:border-slate-700 pb-3">
            Backend &amp; LLM
          </h2>
          <ul className="space-y-2">
            {BackendLLMTechList.map((tech, index) => (
              <li key={index} className="text-base font-medium text-content flex items-center gap-2">
                <span className="text-sky-500">—</span> {tech}
              </li>
            ))}
          </ul>
        </section>
        <section className="flex flex-col gap-4">
          <h2 className="text-xl text-dark-heading dark:text-light-heading md:text-2xl font-bold border-b border-slate-200 dark:border-slate-700 pb-3">
            DevOps &amp; QA
          </h2>
          <ul className="space-y-2">
            {DevOpsTechList.map((tech, index) => (
              <li key={index} className="text-base font-medium text-content flex items-center gap-2">
                <span className="text-sky-500">—</span> {tech}
              </li>
            ))}
          </ul>
        </section>
      </div>
    </main>
  );
}

export default Technologies;
